import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PackageStatusDetails } from 'src/app/core/models/package-status-details.model';
import {
  CONSTANTS,
  MOCK_STATUS_DATA,
  PackageModalData,
} from './package-status-details.constants';

@Component({
  selector: 'app-package-status-details',
  templateUrl: './package-status-details.component.html',
  styleUrls: ['./package-status-details.component.scss'],
  standalone: false,
})
export class PackageStatusDetailsComponent implements OnInit {
  readonly CONST = CONSTANTS;

  statusData!: PackageStatusDetails;
  isSmartValue = false;
  colSize = 3;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: PackageModalData,
    private readonly dialogRef: MatDialogRef<PackageModalData>,
  ) {}

  ngOnInit(): void {
    this.isSmartValue = this.dialogData.isSmartValue;
    this.colSize = this.isSmartValue ? 3 : 4;
    this.statusData = this.dialogData.packageStatusDetails || MOCK_STATUS_DATA;
    this.statusData.trackingNumber = this.dialogData.trackingNumber;
    //TODO: Call BE api to get status detail
  }

  onExit(): void {
    this.dialogRef.close();
  }
}
